import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'clad-ui';
import WrapperScroll from '@app/components/WrapperScroll/WrapperScroll';
import { buildAdViewUrl } from '@app/utils';
import { taggingClickInfoEntitlement } from '@app/utils/gtmTracking';
import EntitlementInfo from '@app/components/EntitlementInfo';
import { styled } from 'linaria/react';
import theme from 'clad-ui/theme/chotot';
import AdItem from './AdItem/AdItem';
import LoadMore from './LoadMore/LoadMore';
import { getAdParams } from './service/getDataByType';
import styles from './tworow.module.scss';
const {
  breakpoints
} = theme;
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w16rgpvr"
});
const LinearBackground = /*#__PURE__*/styled("div")({
  name: "LinearBackground",
  class: "l1apro61"
});
const Grid = /*#__PURE__*/styled("div")({
  name: "Grid",
  class: "g1tzky5o"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "tqc9i0c"
});
const InfoIcon = /*#__PURE__*/styled("div")({
  name: "InfoIcon",
  class: "ihmd6xo"
});
const HelpIconStyled = /*#__PURE__*/styled("div")({
  name: "HelpIconStyled",
  class: "h1jlx0nq"
});
const renderEventName = type => {
  let eventName = 'newest_jobs';
  switch (type) {
    case 'adrecommend':
      eventName = 'job_personalize_ads';
      break;
    case 'entitlement':
      eventName = 'entitlement';
      break;
    case 'urgent-job-ad':
      eventName = 'slot_for_sale';
      break;
    default:
      break;
  }
  return eventName;
};
const GridAds = ({
  title,
  // region,
  isDone,
  link,
  ads,
  total,
  mappingFeaturesAdData,
  allCategoriesFollowId,
  handleClickAdView,
  handleClickLoadMore,
  handleClickHelp,
  adItemLocation,
  adListingParams,
  openProtectedAdModal,
  type,
  isMobile,
  accountId
}) => {
  const [isShownTooltip, setIsShownTooltip] = useState(false);
  const listAdsHtml = [];
  const eventName = renderEventName(type);
  const isEntitlement = type === 'entitlement';
  const isUrgentJobAd = type === 'urgent-job-ad';
  for (let i = 0; i < ads.length; i += 1) {
    const ad = ads[i];
    ad.index = i + 1;
    const adViewUrl = `${buildAdViewUrl(ad, allCategoriesFollowId)}`;
    const adParams = getAdParams(ad, adListingParams);
    listAdsHtml.push(<React.Fragment key={`${ad.type}-${ad.ad_id}-${i}-${ad.account_id}`}>
        <AdItem adInfo={ad} classStr={styles.catMatchingScrollItem} eventName={eventName} mappingFeaturesAdData={mappingFeaturesAdData} handleClickAdView={handleClickAdView} adViewUrl={adViewUrl} adItemLocation={adItemLocation} adParams={adParams} isEntitlement={isEntitlement} isUrgentJobAd={isUrgentJobAd} />
      </React.Fragment>);
  }
  const tooltipText = 'Tìm hiểu thêm về cách hiển thị tin đăng trên mục này';
  const handleClickViewEntitlementDetail = e => {
    taggingClickInfoEntitlement();
    openProtectedAdModal(e);
  };
  const handleClickHelpUrgentJobAd = () => {
    handleClickHelp('slot_for_sale');
    window.open('https://www.vieclamtot.com/chuong-trinh/dang-tin-tuyen-gap-trang-chu');
  };
  const helpIcon = <HelpIconStyled onMouseEnter={() => setIsShownTooltip(true)} onMouseLeave={() => setIsShownTooltip(false)} onClick={handleClickHelpUrgentJobAd} />;
  const help = isShownTooltip && !isMobile ? <Tooltip text={tooltipText} zIndex={1}>
        {helpIcon}
      </Tooltip> : helpIcon;
  return isDone === true && listAdsHtml.length === 0 ? null : <Wrapper className={styles.catMatchingBox}>
      <Title>
        {title}
        {isEntitlement && <InfoIcon role="presentation" onClick={handleClickViewEntitlementDetail} />}
        {isUrgentJobAd && help}
      </Title>
      {isEntitlement && <EntitlementInfo />}
      {listAdsHtml.length === 0 ? <Grid>
          <LinearBackground key="LinearBackground1_1">
            <div className="linearImg" />
          </LinearBackground>
          <LinearBackground key="LinearBackground1_2">
            <div className="linearImg" />
          </LinearBackground>
          <LinearBackground key="LinearBackground1_3">
            <div className="linearImg" />
          </LinearBackground>
          <LinearBackground key="LinearBackground1_4">
            <div className="linearImg" />
          </LinearBackground>
        </Grid> : <WrapperScroll eventName={eventName} total={listAdsHtml.length} cols={4.6} className={`${styles.catMatchingScroll} ${listAdsHtml.length > 3 ? styles.catMatchingScrollTwo : ''}`} isEntitlement={isEntitlement} isMobile={isMobile} accountId={accountId}>
          {listAdsHtml}
        </WrapperScroll>}
      <LoadMore eventName={eventName} link={link} total={total} handleClickLoadmore={handleClickLoadMore} isEntitlement={isEntitlement} isUrgentJobAd={isUrgentJobAd} />
    </Wrapper>;
};
GridAds.propTypes = {
  ads: PropTypes.arrayOf(PropTypes.object).isRequired,
  mappingFeaturesAdData: PropTypes.shape({}),
  isDone: PropTypes.bool.isRequired,
  handleClickAdView: PropTypes.func.isRequired,
  handleClickLoadMore: PropTypes.func.isRequired,
  handleClickHelp: PropTypes.func,
  allCategoriesFollowId: PropTypes.shape({}).isRequired,
  adItemLocation: PropTypes.string,
  adListingParams: PropTypes.arrayOf(PropTypes.object),
  openProtectedAdModal: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  accountId: PropTypes.string.isRequired
};
GridAds.defaultProps = {
  mappingFeaturesAdData: {},
  adItemLocation: '',
  adListingParams: [],
  isMobile: false,
  handleClickHelp: () => {}
};
export default memo(GridAds);

require("../../../.linaria-cache/src/components/GridAds/GridAds.linaria.module.css");